<div class="case-base-page">
	<div class="container">
		<div class="mapping">
			<div>
				<span class="pt-title">PT Image Mapping</span>
				<div class="alert alert-success" *ngIf="alertSuccessMessage" innerHTML="{{alertSuccessMessage}}"></div>
				<div class="nav-search-item">
					<a [routerLink]="['/home']" class="basic-search">Back to Search</a> <span class="hidden-sm hidden-md"> | </span> <a href="{{capOrgURL}}" class="basic-search hidden-sm hidden-md" *ngIf="isCommitteeMember">Return to cap.org</a> <a href="{{staffURL}}" class="basic-search hidden-sm hidden-md" *ngIf="isCAPStaff">Return to Staff Portal Home</a>
				</div>
				<h3 class="title">case-based Images - Search Results</h3>
			</div>
		</div>

		<div class="mapping-search">
			<div class="row d-flex">
				<div class="col-md-4 col-sm-12 col-xs-12">
					<p class="search-note">Search for case-based image mapping data by adjusting Anatomic site search criteria.</p>
					<div class="row">
						<div class="col-md-12 col-sm-6">
							<div class="form-group">
								<label class="label">Anatomic Site:</label>
								<select class="form-control" (change)="onChangeAnatomic($event)" [(ngModel)]="searchByAnatomicForm.anatomicCode" title="{{searchByAnatomicForm.anatomicCode}}">
									<option value="">Select an Anatomic Site Description</option>
									<option *ngFor="let item of anatomicSiteList" value="{{item.code}}">{{item.description}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-12 col-sm-6">
							<div class="form-group">
								<label class="label">Diagnosis:</label>
								<select class="form-control" (change)="onChangeDaigonis($event)" [(ngModel)]="searchByAnatomicForm.diagnosis">
									<option value="">All Diagnosis</option>
									<option *ngFor="let item of primaryDiagnosisList" value="{{item.primaryDiagnosisCode}}">{{item.description}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-12 col-sm-6">
							<div class="row">
								<div class="col-md-7 col-sm-6">
									<div class="form-group">
										<label class="label">Diagnosis Code</label>
										<select class="form-control" (change)="onChangeDaigonis($event)" [(ngModel)]="searchByAnatomicForm.diagnosisCode">
											<option value="">All Diagnosis Code</option>
											<option *ngFor="let item of primaryDiagnosisList" value="{{item.primaryDiagnosisCode}}">{{item.primaryDiagnosisCode}}</option>
										</select>
									</div>
								</div>
								<div class="col-md-5 col-sm-6">
									<div class="form-group">
										<label class="label">Test Result Form</label>
										<select class="form-control" [(ngModel)]="searchByAnatomicForm.testResultForm">
											<option value="">All</option>
											<option value="Y">Yes</option>
											<option value="N">No</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-12 col-sm-6">
							<div class="form-group">
								<label class="label">Slide Type:</label>
								<select class="form-control" (change)="onChangeSubType($event)" [(ngModel)]="searchByAnatomicForm.slideType">
									<option value="">All</option>
									<option *ngFor="let item of slideTypeList" value="{{item.slideTypeCode}}">{{item.description}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-12 col-sm-6">
							<div class="form-group">
								<label class="label">Case:</label>
								<select class="form-control" (change)="onChangeCase($event)" [(ngModel)]="searchByAnatomicForm.case">
									<option value="">All</option>
									<option *ngFor="let item of caseSlideTypeList" value="{{item.caseNumber}}">{{item.caseNumber}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-12 col-sm-12">
							<div class="form-group form-group-md">
								<button class="btn primary-btn" (click)="onClickSearchAnatomicSite()" [disabled]="searchByAnatomicForm.anatomicCode == '' ">Search by Anatomic Site</button>
								<button type="reset" class="btn btn-reset" (click)="onClickResetAnatomicSite()">Reset</button>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 col-sm-12 col-xs-12 hr-line">
					<p class="search-note">Search for case-based image mapping data by entering a Case #.</p>
					<div class="row">
						<div class="col-md-12 col-sm-5">
							<div class="form-group">
								<label class="label">Case #: <span class="program-span">{{program}}</span></label>
								<input type="number" class="form-control" placeholder="Enter Case #" [(ngModel)]="searchByCaseForm.case" (keyup)="onKeyUpEvent($event)">
								<p class="error" *ngIf="searchByCaseForm.caseError">Enter a valid case #</p>
							</div>
						</div>
						<div class="col-md-12 col-sm-4">
							<div class="form-group">
								<label class="label">Availability Status:</label>
								<input type="text" class="form-control" disabled *ngIf="searchByCaseForm.status == ''">
								<p *ngIf="searchByCaseForm.status !== ''">{{searchByCaseForm.status}}</p>
							</div>
						</div>
						<div class="col-md-12 col-sm-3">
							<div class="form-group">
								<label class="label">Availability Reason:</label>
								<input type="text" class="form-control" disabled *ngIf="searchByCaseForm.reason == ''">
								<p *ngIf="searchByCaseForm.reason !== ''">{{searchByCaseForm.reason}}</p>
							</div>
						</div>
					</div>
					<div class="form-group form-group-md">
						<button class="btn primary-btn" type="submit" (click)="onClickSearchCase()" [disabled]="searchByCaseForm.case == null || searchByCaseForm.case == ''">Search by Case #</button>
					</div>
				</div>
				<div class="col-md-4 col-sm-12 col-xs-12">
					<p class="search-note">Search for case-based image mapping data by entering an Image Source Name.
					</p>
					<div class="row">
						<div class="col-md-12 col-sm-6">
							<div class="form-group">
								<label class="label">Image Source Name:</label>
								<input type="text" class="form-control" placeholder="Enter Image Source Name" [(ngModel)]="searchByCaseForm.imageName" maxlength="100">
								<p class="error" *ngIf="isValidImageSourceName">Enter valid image source name</p>
							</div>
						</div>
						<div class="col-md-12 col-sm-12">
							<div class="form-group form-group-md">
								<button class="btn primary-btn" type="submit" (click)="onClickSearchImage()" [disabled]="searchByCaseForm.imageName == ''">Search by Image Source Name</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="copy-and-export hidden-sm hidden-md">
			<a class="icon-with-text" (click)="onClickCopyImage()" *ngIf="isCAPStaff && isCopyImage"> <img alt="copy image" src="./assets/img/copy-file.png" /> Copy Image</a>
			<a class="icon-with-text" (click)="exprotExcel()" *ngIf="isExportExcel && isCAPStaff && caseNumberID == null"> <img alt="export to excel" src="./assets/img/exoprt.png" /> Export to Excel</a>
		</div>
		<div class="tabl-view">
			<table mat-table [dataSource]="dataSource" class="table table-striped" aria-describedby="data source table">
				<ng-container matColumnDef="diagnosis">
					<th id="diagnosis" mat-header-cell *matHeaderCellDef>Diagnosis</th>
					<td mat-cell *matCellDef="let element"> <div [class.italic]="element.diagnosisMenu == 'N'">{{element.diagnosis}}</div></td>
				</ng-container>

				<ng-container matColumnDef="diagnosisCode">
					<th id="diagnosisCode" mat-header-cell *matHeaderCellDef>Diagnosis code</th>
					<td mat-cell *matCellDef="let element"> <div [class.italic]="element.diagnosisMenu == 'N'">{{element.actionDiagnosis}}</div></td>
				</ng-container>

				<ng-container matColumnDef="testResultForm">
					<th id="testResultForm" mat-header-cell *matHeaderCellDef>Test Result Form</th>
					<td mat-cell *matCellDef="let element">
						<span [ngClass]="{ 'red-color italic' : element.diagnosisMenu == 'N' }">{{(element.diagnosisMenu === 'Y') ? 'Yes' : 'No'}}</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="sequance_no">
					<th id="sequance_no" mat-header-cell *matHeaderCellDef>Sequence #</th>
					<td mat-cell *matCellDef="let element"> <div [class.italic]="element.diagnosisMenu == 'N'">{{element.sequence}}</div></td>
				</ng-container>

				<ng-container matColumnDef="externalImageName">
					<th id="externalImageName" mat-header-cell *matHeaderCellDef>External Image Name</th>
					<td mat-cell *matCellDef="let element"> <div [class.italic]="element.diagnosisMenu == 'N'">{{element.externalName}}</div></td>
				</ng-container>

				<ng-container matColumnDef="imageSourceName">
					<th id="imageSourceName" mat-header-cell *matHeaderCellDef>Image Source Name</th>
					<td mat-cell *matCellDef="let element">
						<div [class.italic]="element.diagnosisMenu == 'N'">
							<a class="image-name" (click)="openImageLightBox(element.name, element.imageNumber)">{{(element.name) ? element.name : ''}}</a>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="imageType">
					<th id="imageType" mat-header-cell *matHeaderCellDef>Image Type</th>
					<td mat-cell *matCellDef="let element"><div [class.italic]="element.diagnosisMenu == 'N'">{{element.typeDesc}}</div></td>
				</ng-container>

				<ng-container matColumnDef="imageSubType">
					<th id="imageSubType" mat-header-cell *matHeaderCellDef>Image Sub-Type</th>
					<td mat-cell *matCellDef="let element"><div [class.italic]="element.diagnosisMenu == 'N'">{{element.subTypeDesc}}</div></td>
				</ng-container>

				<ng-container matColumnDef="image_no">
					<th id="image_no" mat-header-cell *matHeaderCellDef>Image #</th>
					<td mat-cell *matCellDef="let element"><div [class.italic]="element.diagnosisMenu == 'N'">{{element.imageNumber}}</div></td>
				</ng-container>

				<ng-container matColumnDef="action">
					<th id="action" mat-header-cell *matHeaderCellDef [ngClass]="{ 'small-cell' : isCommitteeMember }">Action</th>
					<td mat-cell *matCellDef="let element" [ngClass]="{ 'small-cell' : isCommitteeMember }">
						<a (click)="onClickAdd(element)" class="icon hidden-sm hidden-md" [ngClass]="{ 'disabled' : element.diagnosisMenu == 'N' }" *ngIf="!isCommitteeMember && isCAPStaff" title="Add Image">
							<img alt="add" src="./assets/img/add.png" class="enable" />
							<img alt="add" src="./assets/img/disable-add.png" class="disable" />
						</a>
						<a (click)="onClickEdit(element)" class="icon" [ngClass]="{ 'disabled' : !element.name || isQualityControl || element.diagnosisMenu == 'N' }" title="Edit Image Attributes">
							<img alt="edit" src="./assets/img/edit.png" class="enable" />
							<img alt="edit" src="./assets/img/disable-edit.png" class="disable" />
						</a>
						<a (click)="onClickHistory(element)" class="icon" [class.disabled]="!element.name || element.diagnosisMenu == 'N'" title="View Image Log">
							<img alt="log" src="./assets/img/history-clock.png" class="enable" />
							<img alt="log" src="./assets/img/disable-history-clock.png" class="disable" />
						</a>
						<a (click)="onClickDelete(element)" class="icon" [class.disabled]="!element.name || element.diagnosisMenu == 'N'" *ngIf="!isCommitteeMember && isCAPStaff" title="Remove Image">
							<img alt="trash" src="./assets/img/trash.png" class="enable" />
							<img alt="trash" src="./assets/img/disable-trash.png" class="disable" />
						</a>
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

				<ng-container matColumnDef="noRecord">
					<mat-footer-cell *matFooterCellDef colspan="10"> There are no search results found. Please modify your selection and try again. </mat-footer-cell>
				</ng-container>
				<mat-footer-row *matFooterRowDef="['noRecord']" [ngClass]="{'hide':!(isDataSourceBlack)}"></mat-footer-row>
			</table>

			<div [ngClass]="{'hidden-md' : isDataSourceBlack }">
				<mat-paginator
					style-paginator
					[showTotalPages]="showTotalPages"
					[length]="dataSource?.data?.length"
					[pageSize]="pageSize"
					[pageSizeOptions]="pageSizeOptions">
				</mat-paginator>
			</div>

			<div class="copy-and-export bottom-copy hidden-sm hidden-md">
				<a class="icon-with-text" (click)="onClickCopyImage()" *ngIf="isCAPStaff && isCopyImage"> <img alt="copy image" src="./assets/img/copy-file.png" /> Copy Image</a>
				<a class="icon-with-text" (click)="exprotExcel()" *ngIf="isExportExcel && isCAPStaff && caseNumberID == null"> <img alt="export to excel" src="./assets/img/exoprt.png" /> Export to Excel</a>
			</div>
		</div>
	</div>
</div>

<div #lightbox class="image-lightbox">
	<div class="image-lightbox-top-bar">
		<p class="image-lightbox-text-container desktop-only">
			<span class="image-lightbox-image-label">{{anatomicSiteCode}} {{caseNumberID}}</span>
		</p>
		<div (click)="closeImageLightbox()" class="image-lightbox-exit-button">X</div>
	</div>
	<div class="image-lightbox-image-container">
		<img alt="light box image " src={{lightBoxImagePath}} class="image-lightbox-image">
	</div>
	<p class="image-lightbox-text-container mobile-only">
		<span class="image-lightbox-image-label">{{anatomicSiteCode}} {{caseNumberID}}</span>
	</p>
</div>